import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';

import UnassessedOrgComponent from './UnassessedOrgComponent';
import OrgAssessmentContainer from '../../containers/OrgAssessmentContainer';

const OrgComponentRouter = ({ match, ...props }) => {
  const { assessmentHistorySummaries } = props;
  const path = match.path;

  return (
    <Switch>
      <Route
        path={`${path}/:assessmentKey/detail/:subOrgId/:view(recommendations|squad-scorecard|org-trends|insights|analyze)`}
        render={({ match: legacyMatch, location }) => {
          const { assessmentKey, view: rawView } = legacyMatch.params;
          const view = rawView === 'analyze' ? 'insights' : rawView;
          const base = `${match.url}/${assessmentKey}/detail`;
          const pathname =
            view === 'squad-scorecard'
              ? `${base}/squad-scorecard`
              : `${base}/${view}`;

          return <Redirect to={{ pathname, search: location.search }} />;
        }}
      />
      <Route
        path={`${path}/:assessmentKey/detail`}
        render={(routerProps) => (
          <OrgAssessmentContainer {...props} {...routerProps} />
        )}
      />
      <Route
        path={`${path}/:assessmentKey`}
        exact
        render={({ match: m, location }) => (
          <Redirect
            to={{
              pathname: `${match.url}/${m.params.assessmentKey}/detail/recommendations`,
              search: location.search,
            }}
          />
        )}
      ></Route>
      <Route
        path={path}
        exact
        render={({ location }) =>
          assessmentHistorySummaries.length > 0 ? (
            <Redirect
              to={{
                pathname: `${match.url}/${assessmentHistorySummaries[0].assessment_key}/detail/recommendations`,
                search: location.search,
              }}
            />
          ) : (
            <UnassessedOrgComponent {...props} />
          )
        }
      />
    </Switch>
  );
};

export default OrgComponentRouter;
